import { useMutation, useQueryClient } from "@tanstack/react-query";
import { likePost, unlikePost } from "../services/postServices";
import { FEED_QUERY_KEYS } from "../queryKeys";

interface UsePostLikeMutationProps {
  postId: number;
}

export const usePostLikeMutation = ({ postId }: UsePostLikeMutationProps) => {
  const queryClient = useQueryClient();

  const likeMutation = useMutation({
    mutationFn: () => likePost(postId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...FEED_QUERY_KEYS.all, "posts", "list"] });
      queryClient.invalidateQueries({ queryKey: FEED_QUERY_KEYS.postData(postId) });
    },
  });

  const unlikeMutation = useMutation({
    mutationFn: () => unlikePost(postId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...FEED_QUERY_KEYS.all, "posts", "list"] });
      queryClient.invalidateQueries({ queryKey: FEED_QUERY_KEYS.postData(postId) });
    },
  });

  return {
    likePost: likeMutation.mutate,
    isLiking: likeMutation.isPending,
    unlikePost: unlikeMutation.mutate,
    isUnliking: unlikeMutation.isPending,
  };
};
